define.alias("ember-power-select/components/power-select/search-message", "settings/components/power-select/search-message");